// src/components/ads-admin/utils.js

export function fmtDt(x) {
  if (!x) return "-";
  const d = new Date(x);
  if (Number.isNaN(d.getTime())) return String(x);
  return d.toLocaleString();
}

export function toneFromStatus(status) {
  const s = String(status || "").toLowerCase();
  if (s === "active") return "success";
  if (s === "inactive") return "neutral";
  if (s.includes("success") || s.includes("done") || s.includes("completed")) return "success";
  if (s.includes("running") || s.includes("in_progress") || s.includes("processing")) return "info";
  if (s.includes("pending") || s.includes("queued")) return "warn";
  if (s.includes("fail") || s.includes("error")) return "error";
  return "neutral";
}

export function sanitizeSource(x) {
  const s = String(x || "").trim().toLowerCase();
  return s || "meta";
}

export function getBrandId(b) {
  const raw = b?.id ?? b?.brand_id ?? b?.brandId;
  const n = Number(raw);
  return Number.isFinite(n) && n > 0 ? n : null;
}

export async function copyToClipboard(text) {
  const t = String(text || "");
  if (!t) return false;

  try {
    if (navigator?.clipboard?.writeText) {
      await navigator.clipboard.writeText(t);
      return true;
    }
  } catch {
    // fallback below
  }

  try {
    const ta = document.createElement("textarea");
    ta.value = t;
    ta.setAttribute("readonly", "");
    ta.style.position = "fixed";
    ta.style.left = "-9999px";
    document.body.appendChild(ta);
    ta.select();
    document.execCommand("copy");
    document.body.removeChild(ta);
    return true;
  } catch {
    return false;
  }
}

export function humanizeToastMessage(msg) {
  const s = String(msg || "").trim();
  if (!s) return "Something went wrong.";

  if (s.includes("ADS_META_ACCESS_TOKEN"))
    return "Meta access token is missing. Add it to your server config and restart.";
  if (s.includes("ADS_GOOGLE_SERPAPI_API_KEY"))
    return "SerpApi key is missing. Add it to your server config and restart.";

  if (s.toLowerCase().includes("meta api error")) {
    // Preserve the actual Meta error body so it's visible in the toast.
    const detail = s.slice(s.indexOf(":") + 1).trim().slice(0, 220);
    return `Meta API error - ${detail || "check token permissions and the advertiser ID."}`;
  }
  if (s.toLowerCase().includes("serpapi"))
    return "Google/SerpApi request failed. Check your key and try a different search query.";
  if (s.toLowerCase().includes("rate limit"))
    return "Rate limited by provider. Try again in a bit.";

  if (s.toLowerCase().includes("run not found")) return "That ingestion run no longer exists.";
  if (s.toLowerCase().includes("brand not found")) return "That brand is not available for Ads Discovery.";
  if (s.toLowerCase().includes("entity not found")) return "That advertiser entry no longer exists.";

  if (s.startsWith("{") || s.startsWith("[")) return "Something went wrong. Please try again.";
  if (s.length > 160) return s.slice(0, 160) + "…";
  return s;
}